/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} UsageInputs */



/**
* | output |
* | --- |
* | "Usage" |
*
* @param {UsageInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const usage = /** @type {((inputs?: UsageInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<UsageInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Utilisation")
	if (locale === "de") return /** @type {LocalizedString} */ ("Verwendung")
	if (locale === "it") return /** @type {LocalizedString} */ ("Utilizzo")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Использование")
	if (locale === "es") return /** @type {LocalizedString} */ ("Uso")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("用法")
	if (locale === "ja") return /** @type {LocalizedString} */ ("使用法")
	if (locale === "hi") return /** @type {LocalizedString} */ ("प्रयोग")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Uso")
	return /** @type {LocalizedString} */ ("Usage")
});